import { TooltipMessage } from "@/playground/components/DevHome/table/pages/conversation_center/components/TooltipMessage/TooltipMessage";
import { CellIcon } from "../../../pages/conversation_center/components/CellIcon/CellIcon";
import { HeaderSimple } from "../../../pages/conversation_center/components/HeaderSimple/HeaderSimple";
import type { ColumnType } from "../columns.decl";
import { type TranscriptMapProps, transcriptMap } from "./transcript.constants";

const transcriptIconDataTest = "available_transcript_icon";

export const transcriptConfig: ColumnType = {
  id: "transcript",
  label: <HeaderSimple label="transcript" />,
  renderer: (_, value: keyof TranscriptMapProps) => {
    if (value === "AVAILABLE") {
      const { title, description, ...otherProps } = transcriptMap[value];

      return (
        <CellIcon
          dataTest={transcriptIconDataTest}
          {...otherProps}
          tooltip={<TooltipMessage title={title} description={description} />}
        />
      );
    }
  },
};
